import { Grid, TextField } from '@mui/material';
import { ILoanAsset } from '../../../../../../Interfaces/Asset/ILoanAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type LoanAssetViewProps = ITestamentAssetsViewProps<ILoanAsset>;

export function LoanAssetView({ asset, setAsset }: LoanAssetViewProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label='Gesamtbetrag der Verbindlichkeit in Euro'
          size='small'
          value={asset.data.amount || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                amount: Number(event.target.value),
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Angaben zu den Verbindlichkeiten'
          rows={3}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
